import React from 'react'
import { VehiclePhotosUpload } from '../VehiclePhotosUpload'
import { VehicleExistingPhotos } from '../VehicleExistingPhotos'
import { VehicleSocialMedia } from '../VehicleSocialMedia'

interface VehicleEditStep5MediaProps {
 formData: {
 photos: File[]
 videoUrl?: string
 instagramUrl?: string
 youtubeUrl?: string
 tiktokUrl?: string
 facebookUrl?: string
 }
 existingPhotos: Array<{ id: string; url: string; isPrimary?: boolean; order?: number }>
 primaryPhotoIndex: number
 errors: Record<string, string>
 onInputChange: (field: string, value: any) => void
 onPrimaryPhotoChange: (index: number) => void
 onRemoveExistingPhoto: (photoId: string) => void
 onSetPrimaryPhoto: (photoId: string) => void
}

export const VehicleEditStep5Media: React.FC<VehicleEditStep5MediaProps> = ({
 formData,
 existingPhotos,
 primaryPhotoIndex,
 errors,
 onInputChange,
 onPrimaryPhotoChange,
 onRemoveExistingPhoto,
 onSetPrimaryPhoto
}) => {
 return (
 <div 
 onClick={(e) => {
 e.stopPropagation()
 }}
 >
 {/* Fotos Existentes */}
 <VehicleExistingPhotos
 photos={existingPhotos}
 onRemovePhoto={onRemoveExistingPhoto}
 onSetPrimaryPhoto={onSetPrimaryPhoto}
 />

 {/* Upload de Novas Fotos */}
 <VehiclePhotosUpload
 photos={formData.photos}
 onPhotosChange={(photos) => onInputChange('photos', photos)}
 primaryPhotoIndex={primaryPhotoIndex}
 onPrimaryPhotoChange={onPrimaryPhotoChange}
 error={errors.photos}
 />

 {/* Redes Sociais */}
 <VehicleSocialMedia
 videoUrl={formData.videoUrl}
 instagramUrl={formData.instagramUrl}
 youtubeUrl={formData.youtubeUrl}
 tiktokUrl={formData.tiktokUrl}
 facebookUrl={formData.facebookUrl}
 onFieldChange={onInputChange}
 />
 </div>
 )
}

